import React from 'react';

import styles from './styles.module.scss';

const OrDivider = () => <span className={styles.orDivider}>or</span>;

export default OrDivider;
